module.exports = __webpack_public_path__ + "static/media/logo-ciemne2.0c8aa709.png";